import { Box, FormControlLabel, Stack } from '@mui/material';
import { Button, Checkbox, Typography } from '@sweep-io/sweep-design';
import { openIntercom } from '../../../dashboard/customerSupportHelper';
import WithConnectOrgPermission from '../../../common/WithConnectOrgPermission';

const ConnectStartInDialog = ({
  onConnectStart,
  forceProduction,
  isSandbox,
  setIsSandbox,
  title,
  description,
  isDuplicateProdErrorState,
}: {
  onConnectStart: () => void;
  forceProduction: boolean;
  isSandbox: boolean;
  setIsSandbox: (isSandbox: boolean) => void;
  title: string;
  description: React.ReactNode;
  isDuplicateProdErrorState: boolean;
}) => {
  return (
    <Stack padding={3}>
      <Stack flex={1} justifyContent="center">
        <Box display="flex" gap={0.5} alignItems="center" mb={1}>
          <Typography variant="h2">{title}</Typography>
        </Box>
        <Box mb={4}>
          <Typography variant="body">{description}</Typography>
        </Box>
        {!forceProduction && !isDuplicateProdErrorState && (
          <Box display="flex" gap={1.5} alignItems="center">
            <FormControlLabel
              sx={{
                '.MuiFormControlLabel-label': { lineHeight: 2 },
              }}
              label={<Typography variant="body">Connect to a Salesforce Sandbox</Typography>}
              control={
                <Checkbox
                  checked={isSandbox ?? false}
                  onChange={(val) => {
                    setIsSandbox(val.target.checked);
                  }}
                />
              }
            />
          </Box>
        )}
      </Stack>
      <Box display="flex" gap={2} justifyContent="flex-end" alignItems="center">
        <Button size="medium" startIconName="Chats" onClick={() => openIntercom()} variant="system">
          Talk to us
        </Button>
        {!isDuplicateProdErrorState && (
          <WithConnectOrgPermission>
            <Button size="medium" onClick={onConnectStart}>
              Continue
            </Button>
          </WithConnectOrgPermission>
        )}
      </Box>
    </Stack>
  );
};

export default ConnectStartInDialog;
